import { QueryClient } from "@tanstack/react-query";
import { handleApiError } from "../util/errorHandler";

/**
 * Configuração do QueryClient para React Query
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tempo de cache padrão: 5 minutos
      staleTime: 5 * 60 * 1000,
      // Tempo de cache em background: 10 minutos
      cacheTime: 10 * 60 * 1000,
      // Retry automático em caso de erro
      retry: 1,
      // Refetch quando a janela ganha foco
      refetchOnWindowFocus: false,
      // Refetch quando reconecta
      refetchOnReconnect: true,
      // Não refetch automaticamente em mount
      refetchOnMount: true,
    },
    mutations: {
      // Retry em mutações
      retry: 0,
      // Tratamento de erro global para mutações
      onError: (error) => {
        handleApiError(error, { context: "ReactQuery.mutation", showToast: true });
      },
    },
  },
});

